import React from "react";
import Button from "../Button";

import { importDataWithCNPJ } from "../../api/branches";

export default (props) => {
  const [loading, setLoading] = React.useState(false);
  function onClick() {
    setLoading(true);
    importDataWithCNPJ(props.cnpj)
      .then((resp) => {
        if (props.onSuccess) {
          props.onSuccess(resp);
        }
      })
      .catch((error) => {
        console.debug(error);
        if (error.invalid_cnpj) {
          if (error.invalid_cnpj.includes("CNPJ situation:")) {
            const [_, msg] = error.invalid_cnpj.split("CNPJ situation:");
            alert(
              `ERRO: O CNPJ encontra-se com a situação: ${msg}`.toUpperCase()
            );
            return;
          } else if (error.invalid_cnpj.includes("Invalid CNPJ")) {
            alert("CNPJ INVÁLIDO");
            return;
          }
        } else if (error.rate_limit) {
          alert("FALHA NA CONSULTA. TENTE NOVAMENTE EM 15 SEGUNDOS!");
        } else if (error.cnae_error) {
          alert("CODIGO CNAE NÃO LOCALIZADO");
        }
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }
  return (
    <Button disabled={loading} onClick={onClick}>
      {loading ? (
        <i className="fas fa-spinner fa-pulse" />
      ) : (
        <i className="fas fa-search" />
      )}
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/_components/ImportCNPJ/index.jsx